import React from 'react';
import ConsensusTableWidgetBuilder from './ConsensusTableWidgetBuilder';
import ConsensusTableWidgetRenderer from './ConsensusTableWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ConsensusTableWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable } from '@fortawesome/free-solid-svg-icons';

export { default as ConsensusTableWidgetBuilder } from './ConsensusTableWidgetBuilder';
export { default as ConsensusTableWidgetRenderer } from './ConsensusTableWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'consensus_table',
  meta: {
    label: 'Consensus Table',
    icon: React.createElement(FontAwesomeIcon, { icon: faTable }),
    description: 'Consensus estimates with broker averages and fiscal period breakdowns',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'CONSENSUS_TABLE',
    params: [],
  },
  defaultSize: { w: 8, h: 5, minW: 5, minH: 4 },
  defaultConfig: () => ({} as ConsensusTableWidgetConfig),
  Builder: ConsensusTableWidgetBuilder,
  Renderer: ConsensusTableWidgetRenderer,
  Preview,
};
